import { wrap } from 'girder/utilities/PluginUtils';
import events from 'girder/events';
import FolderListWidget from 'girder/views/widgets/FolderListWidget';


wrap(FolderListWidget, 'render', function (render) {
    const root = this;

    render.call(this);

    function updateAnalysesResources(event) {
        const target = $(event.currentTarget);
        const cid = target.attr('g-folder-cid');
        if (target.prop('checked')) {
            this.checked.push(cid);
        } else {
            const idx = this.checked.indexOf(cid);
            if (idx !== -1) {
                this.checked.splice(idx, 1);
            }
        }
        this.trigger('g:checkboxesChanged');
        this.trigger('g:analysesboxesChanged');
    }

    this.events['change .g-list-checkbox'] = updateAnalysesResources;
    this.delegateEvents();
});



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/folderList.js